export class Editor {
    async initializeEditor(editor, type, options) {
        let defaultOptions = {
            characterMax: 0
        };
        options = {...defaultOptions, ...options};

        import(/* webpackIgnore: true */ '/build/translations/en.js');
        import(/* webpackIgnore: true */ '/build/translations/de.js');

        const {default: ClassicEditor} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
            );
        const {default: Essentials} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-essentials/src/essentials'
            );

        const {default: Alignment} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-alignment/src/alignment'
            );
        const {default: Autoformat} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-autoformat/src/autoformat'
            );
        const {default: BlockQuote} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-block-quote/src/blockquote'
            );
        const {default: Bold} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-basic-styles/src/bold'
            );
        // const {default: Code} = await import(
        //     /* webpackChunkName: "chunk-ckeditor" */
        //     '@ckeditor/ckeditor5-basic-styles/src/code'
        //     );
        // const {default: CodeBlock} = await import(
        //     /* webpackChunkName: "chunk-ckeditor" */
        //     '@ckeditor/ckeditor5-code-block/src/codeblock'
        //     );
        const {default: Font} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-font/src/font'
            );
        const {default: Heading} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-heading/src/heading'
            );
        const {default: Highlight} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-highlight/src/highlight'
            );
        const {default: HorizontalLine} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-horizontal-line/src/horizontalline'
            );
        const {default: Indent} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-indent/src/indent'
            );
        const {default: IndentBlock} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-indent/src/indentblock'
            );
        const {default: Italic} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-basic-styles/src/italic'
            );
        const {default: Link} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-link/src/link'
            );
        const {default: List} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-list/src/list'
            );
        // const {default: MediaEmbed} = await import(
        //     /* webpackChunkName: "chunk-ckeditor" */
        //     '@ckeditor/ckeditor5-media-embed/src/mediaembed'
        //     );
        const {default: Paragraph} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-paragraph/src/paragraph'
            );
        const {default: PasteFromOffice} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice'
            );
        const {default: RemoveFormat} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-remove-format/src/removeformat'
            );

        const {default: SpecialCharacters} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-special-characters/src/specialcharacters'
            );
        const {default: SpecialCharactersText} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-special-characters/src/specialcharacterstext'
            );
        const SpecialCharactersApp = function (editor) {
            const specialCharacters = editor.plugins.get('SpecialCharacters');
            specialCharacters.addItems('Emoji', [
                {title: 'Grinning Face', character: '😀'}, {title: 'Grinning Face with Big Eyes', character: '😃'}, {title: 'Grinning Face with Smiling Eyes', character: '😄'}, {title: 'Beaming Face with Smiling Eyes', character: '😁'}, {title: 'Grinning Squinting Face', character: '😆'}, {title: 'Grinning Face with Sweat', character: '😅'}, {title: 'Rolling on the Floor Laughing', character: '🤣'}, {title: 'Face with Tears of Joy', character: '😂'}, {title: 'Slightly Smiling Face', character: '🙂'}, {title: 'Upside-Down Face', character: '🙃'}, {title: 'Winking Face', character: '😉'}, {title: 'Smiling Face with Smiling Eyes', character: '😊'}, {title: 'Smiling Face with Halo', character: '😇'}, {title: 'Smiling Face with Hearts', character: '🥰'}, {title: 'Smiling Face with Heart-Eyes', character: '😍'}, {title: 'Star-Struck', character: '🤩'}, {title: 'Face Blowing a Kiss', character: '😘'}, {title: 'Kissing Face', character: '😗'}, {title: 'Smiling Face', character: '☺️'}, {title: 'Kissing Face with Closed Eyes', character: '😚'}, {title: 'Kissing Face with Smiling Eyes', character: '😙'}, {title: 'Smiling Face with Tear', character: '🥲'}, {title: 'Face Savoring Food', character: '😋'}, {title: 'Face with Tongue', character: '😛'}, {title: 'Winking Face with Tongue', character: '😜'}, {title: 'Zany Face', character: '🤪'}, {title: 'Squinting Face with Tongue', character: '😝'}, {title: 'Money-Mouth Face', character: '🤑'}, {title: 'Hugging Face', character: '🤗'}, {title: 'Face with Hand Over Mouth', character: '🤭'}, {title: 'Shushing Face', character: '🤫'}, {title: 'Thinking Face', character: '🤔'}, {title: 'Zipper-Mouth Face', character: '🤐'}, {title: 'Face with Raised Eyebrow', character: '🤨'}, {title: 'Neutral Face', character: '😐'}, {title: 'Expressionless Face', character: '😑'}, {title: 'Face Without Mouth', character: '😶'}, {title: 'Smirking Face', character: '😏'}, {title: 'Unamused Face', character: '😒'}, {title: 'Face with Rolling Eyes', character: '🙄'}, {title: 'Grimacing Face', character: '😬'}, {title: 'Lying Face', character: '🤥'}, {title: 'Relieved Face', character: '😌'}, {title: 'Pensive Face', character: '😔'}, {title: 'Sleepy Face', character: '😪'}, {title: 'Drooling Face', character: '🤤'}, {title: 'Sleeping Face', character: '😴'}, {title: 'Face with Medical Mask', character: '😷'}, {title: 'Face with Thermometer', character: '🤒'}, {title: 'Face with Head-Bandage', character: '🤕'}, {title: 'Nauseated Face', character: '🤢'}, {title: 'Face Vomiting', character: '🤮'}, {title: 'Sneezing Face', character: '🤧'}, {title: 'Hot Face', character: '🥵'}, {title: 'Cold Face', character: '🥶'}, {title: 'Woozy Face', character: '🥴'}, {title: 'Dizzy Face', character: '😵'}, {title: 'Exploding Head', character: '🤯'}, {title: 'Cowboy Hat Face', character: '🤠'}, {title: 'Partying Face', character: '🥳'}, {title: 'Disguised Face', character: '🥸'}, {title: 'Smiling Face with Sunglasses', character: '😎'}, {title: 'Nerd Face', character: '🤓'}, {title: 'Face with Monocle', character: '🧐'}, {title: 'Confused Face', character: '😕'}, {title: 'Worried Face', character: '😟'}, {title: 'Slightly Frowning Face', character: '🙁'}, {title: 'Frowning Face', character: '☹️'}, {title: 'Face with Open Mouth', character: '😮'}, {title: 'Hushed Face', character: '😯'}, {title: 'Astonished Face', character: '😲'}, {title: 'Flushed Face', character: '😳'}, {title: 'Pleading Face', character: '🥺'}, {title: 'Frowning Face with Open Mouth', character: '😦'}, {title: 'Anguished Face', character: '😧'}, {title: 'Fearful Face', character: '😨'}, {title: 'Anxious Face with Sweat', character: '😰'}, {title: 'Sad but Relieved Face', character: '😥'}, {title: 'Crying Face', character: '😢'}, {title: 'Loudly Crying Face', character: '😭'}, {title: 'Face Screaming in Fear', character: '😱'}, {title: 'Confounded Face', character: '😖'}, {title: 'Persevering Face', character: '😣'}, {title: 'Disappointed Face', character: '😞'}, {title: 'Downcast Face with Sweat', character: '😓'}, {title: 'Weary Face', character: '😩'}, {title: 'Tired Face', character: '😫'}, {title: 'Yawning Face', character: '🥱'}, {title: 'Face with Steam From Nose', character: '😤'}, {title: 'Pouting Face', character: '😡'}, {title: 'Angry Face', character: '😠'}, {title: 'Face with Symbols on Mouth', character: '🤬'}, {title: 'Smiling Face with Horns', character: '😈'}, {title: 'Angry Face with Horns', character: '👿'}, {title: 'Skull', character: '💀'}, {title: 'Skull and Crossbones', character: '☠️'}, {title: 'Pile of Poo', character: '💩'}, {title: 'Kiss Mark', character: '💋'},
                {title: 'Heart with Arrow', character: '💘'}, {title: 'Heart with Ribbon', character: '💝'}, {title: 'Sparkling Heart', character: '💖'}, {title: 'Growing Heart', character: '💗'}, {title: 'Beating Heart', character: '💓'}, {title: 'Revolving Hearts', character: '💞'}, {title: 'Two Hearts', character: '💕'}, {title: 'Heart Decoration', character: '💟'}, {title: 'Heart Exclamation', character: '❣️'}, {title: 'Broken Heart', character: '💔'}, {title: 'Red Heart', character: '❤️'}, {title: 'Orange Heart', character: '🧡'}, {title: 'Yellow Heart', character: '💛'}, {title: 'Green Heart', character: '💚'}, {title: 'Blue Heart', character: '💙'}, {title: 'Purple Heart', character: '💜'}, {title: 'Brown Heart', character: '🤎'}, {title: 'Black Heart', character: '🖤'}, {title: 'White Heart', character: '🤍'}, {title: 'Zzz', character: '💤'},
            ]);
        }

        // const {default: Table} = await import(
        //     /* webpackChunkName: "chunk-ckeditor" */
        //     '@ckeditor/ckeditor5-table/src/table'
        //     );
        // const {default: TableToolbar} = await import(
        //     /* webpackChunkName: "chunk-ckeditor" */
        //     '@ckeditor/ckeditor5-table/src/tabletoolbar'
        //     );
        // const {default: TableProperties} = await import(
        //     /* webpackChunkName: "chunk-ckeditor" */
        //     '@ckeditor/ckeditor5-table/src/tableproperties'
        //     );
        // const {default: TableCellProperties} = await import(
        //     /* webpackChunkName: "chunk-ckeditor" */
        //     '@ckeditor/ckeditor5-table/src/tablecellproperties'
        //     );
        const {default: Underline} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-basic-styles/src/underline'
            );

        const {default: WordCount} = await import(
            /* webpackChunkName: "chunk-ckeditor" */
            '@ckeditor/ckeditor5-word-count/src/wordcount'
            );

        const WordCountLimiter = function (editor) {
            if (!(options.characterMax > 0)) {
                return;
            }

            const form = editor.sourceElement.closest('form');
            const editorParent = editor.sourceElement.parentNode;

            const CharacterLimiter = document.createElement('div');
            CharacterLimiter.classList.add('editor-character-limiter')
            const CharacterLimiterSvg = '<svg viewbox="0 0 40 40" width="40" height="40" xmlns="http://www.w3.org/2000/svg">' +
                '    <circle stroke="hsl(0, 0%, 93%)" stroke-width="3" fill="none" cx="20" cy="20" r="17" />' +
                '    <circle stroke="hsl(202, 92%, 59%)" stroke-width="3" stroke-dasharray="134,534" stroke-linecap="round" fill="none" cx="20" cy="20" r="17" />' +
                '    <text x="50%" y="50%" dominant-baseline="central" text-anchor="middle"></text>' +
                '</svg>';
            let message = 'Anzahl der HTML Zeichen';
            let title = 'Je mehr Text formatiert und sozusagen dekoriert wird, desto mehr HTML-Code wird generiert und ihr könnt weniger Zeichen benutzen.\n' +
                'Falls ihr Formatierungen löschen wollt: Text markieren und in der Toolbar \'Tx\' anklicken.';
            CharacterLimiter.innerHTML = CharacterLimiterSvg + '<span title="' + title + '">' + message + '</span>';
            editor.sourceElement.parentNode.insertBefore(CharacterLimiter, editor.sourceElement.nextSibling);

            let submit = form.querySelector('[type="submit"]');
            let progressCircle = editorParent.querySelector('.editor-character-limiter svg circle:nth-child(2)');
            let charactersBox = editorParent.querySelector('.editor-character-limiter svg text');
            let circleCircumference = Math.floor(2 * Math.PI * progressCircle.getAttribute('r'));

            editor.plugins.get('WordCount').on('update', (event, stats) => {
                let charactersHtml = editor.getData().length;
                let isLimitExceeded = charactersHtml > options.characterMax;
                let isCloseToLimit = !isLimitExceeded && charactersHtml > options.characterMax * .8;
                let charactersProgress = charactersHtml / options.characterMax * circleCircumference;
                let circleDashArray = Math.min(charactersProgress, circleCircumference);

                progressCircle.setAttribute('stroke-dasharray', circleDashArray + ',' + circleCircumference);
                charactersBox.textContent = isLimitExceeded ? '-' + (charactersHtml - options.characterMax) : charactersHtml;

                editorParent.classList.toggle('limit-close', isCloseToLimit);
                editorParent.classList.toggle('limit-exceeded', isLimitExceeded);
                submit.toggleAttribute('disabled', isLimitExceeded);
            });
        }

        ClassicEditor.builtinPlugins = [
            Essentials,
            Autoformat,
            Paragraph,
            PasteFromOffice,
            RemoveFormat,
        ];
        if (options.characterMax > 0) {
            ClassicEditor.builtinPlugins.push(WordCount, WordCountLimiter);
        }

        ClassicEditor.defaultConfig = {
            toolbar: {
                items: [
                    'removeFormat', '|', 'undo', 'redo'
                ],
                shouldNotGroupWhenFull: true
            },
            ui: {
                viewportOffset: {
                    top: 70
                }
            },
            language: 'de'
        };

        const AppClassicEditorConfig = {
            link: {
                decorators: {
                    openInNewTab: {
                        mode: 'automatic',
                        // mode: 'manual',
                        label: 'Open in a new tab',
                        callback: url => !( /^((https?:)?\/\/(www\.)?schambereich\.(org|net))?\//.test(url) ),
                        attributes: {
                            target: '_blank',
                            rel: 'noopener noreferrer'
                        }
                    },
                    /*detectDownloadable: {
                        mode: 'manual',
                        callback: url => url.endsWith('.pdf'),
                        label: 'Downloadable',
                        attributes: {
                            download: 'file.pdf'
                        }
                    }*/
                },
            },
            // alignment: {
            //     options: ['left', 'right', 'center', 'justify']
            // },
            // mediaEmbed: {
            //     removeProviders: [
            //         'dailymotion', 'spotify', 'youtube', 'vimeo',
            //        // Without generation node_modules/@ckeditor/ckeditor5-media-embed/src/mediaembed.js
            //         'instagram', 'twitter', 'googleMaps', 'flickr', 'facebook'
            //     ]
            // },
            language: 'de'
        };

        if (type === 'full') {
            return ClassicEditor.create(editor, {
                plugins: [
                    ...ClassicEditor.builtinPlugins,
                    Alignment,
                    BlockQuote,
                    Bold,
                    // Code,
                    // CodeBlock,
                    Font,
                    Heading,
                    Highlight,
                    HorizontalLine,
                    Indent,
                    IndentBlock,
                    Italic,
                    Link,
                    List,
                    // MediaEmbed,
                    SpecialCharacters, SpecialCharactersApp, SpecialCharactersText,
                    // Table,
                    // TableToolbar, TableProperties, TableCellProperties,
                    Underline,
                ],
                toolbar: {
                    items: [
                        'heading',
                        'bold', 'italic', 'underline', '|',
                        // 'code',
                        // 'codeBlock',
                        'blockQuote',
                        'link',
                        'highlight',
                        'horizontalLine',
                        // 'mediaEmbed',
                        // 'insertTable',
                        'specialCharacters',
                        '|',
                        'alignment', 'outdent', 'indent', '|',
                        'bulletedList', 'numberedList', '|',
                        'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor', '|',
                        // 'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify',
                        '|',
                        'removeFormat', '|', 'undo', 'redo',
                    ]
                },
                ...AppClassicEditorConfig
            }).catch(error => {
                console.error(error);
            });
        } else {
            return ClassicEditor.create(editor, {
                plugins: [
                    ...ClassicEditor.builtinPlugins,
                    Bold,
                    Italic,
                    Link,
                    Underline,
                    SpecialCharacters, SpecialCharactersApp, SpecialCharactersText,
                ],
                toolbar: {
                    items: [
                        'bold', 'italic', 'underline',
                        'link',
                        'specialCharacters', '|',
                        'removeFormat', '|', 'undo', 'redo'
                    ]
                },
                ...AppClassicEditorConfig
            }).catch(error => {
                console.error(error);
            });
        }
    }
}
